import axios from 'axios'

class UserCompanyService {
  async fetchFreshUserAndCompany(user: string, company: string) {
    const response = await axios.post('/users/fresh-user-and-company', {
      user,
      company
    }, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }
}

export const userCompanyService = new UserCompanyService()